import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Switch } from "./ui/switch";
import { istDT } from "./PartnerBriefCard";

const dm = (s) => new Date(`${s}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

const History = ({ rows }) => (
  <div className="mt-3 text-xs text-muted-foreground space-y-0.5" data-testid="weekly-insights-history">
    <div>Last sent:</div>
    {rows.map((h) => (
      <div key={h.date}>Week {dm(h.week_start)} to {dm(h.week_end)} · {istDT(h.sent_at)} · to {h.sent.map((s) => `${s.name || s.to}${s.ok ? "" : " (failed)"}`).join(", ") || "no founders"}{h.ai_ok ? "" : " · numbers only, AI summary failed"}</div>
    ))}
  </div>
);

export const WeeklyInsightsCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/weekly-insights").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const on = d.settings.enabled;
  const pon = d.settings.personal_enabled;
  const flip = (v, key = "enabled") => {
    setBusy(true);
    const what = key === "enabled" ? "Saturday insights email" : "Personal weekly emails";
    api.put("/weekly-insights", { [key]: v })
      .then(() => { toast.success(`${what} switched ${v ? "on" : "off"}`); load(); })
      .catch((e) => toast.error(errMsg(e))).finally(() => setBusy(false));
  };
  return (
    <div className="ax-panel p-4 mb-4" data-testid="weekly-insights-card">
      <div className="ax-label mb-1 flex items-center gap-1.5"><Mail className="h-3.5 w-3.5" />Saturday insights email</div>
      <p className="text-sm text-muted-foreground mb-3">Every Saturday at 5:30 PM India time, each founder gets an email with the week's top wins and risks written by AI from sales, UIDs, production and team follow-up numbers, with the numbers behind them.</p>
      <label className="flex items-center gap-2 text-sm w-fit">
        <Switch data-testid="weekly-insights-enabled" checked={on} disabled={busy} onCheckedChange={flip} />
        <span data-testid="weekly-insights-status">{on ? "On · next one goes out on Saturday at 5:30 PM" : "Switched off · no email is sent"}</span>
      </label>
      {d.history.length > 0 && <History rows={d.history} />}
      <p className="text-sm text-muted-foreground mt-4 mb-3">At the same time, everyone who owns leads or UIDs gets their own week: AI-written wins and focus points from their leads, Pre-POs, POs, CS jobs, follow-ups and business plan.</p>
      <label className="flex items-center gap-2 text-sm w-fit">
        <Switch data-testid="weekly-insights-personal-enabled" checked={pon} disabled={busy} onCheckedChange={(v) => flip(v, "personal_enabled")} />
        <span data-testid="weekly-insights-personal-status">{pon ? "On · each salesperson gets their own Saturday email" : "Switched off · no personal emails"}</span>
      </label>
      {d.people_last && <div className="mt-2 text-xs text-muted-foreground" data-testid="weekly-insights-people-last">Last sent {istDT(d.people_last.sent_at)} to {d.people_last.sent.filter((s) => s.ok).length} people</div>}
    </div>
  );
};
